<template>
  <div class="password">
    <div class="form">
      <div class="from_item">
        <div class="from_name">
          原密码
        </div>
        <div class="from_input">
          <input type="password" v-model="from.password_old" @blur="passwordoldfn">
        </div>
      </div>
      <div class="from_item">
        <div class="from_name">
          新密码
        </div>
        <div class="from_input">
          <input type="password" v-model="from.password" @blur="inputpasswordfn">
        </div>
      </div>
      <div class="from_item">
        <div class="from_name">
          确认密码
        </div>
        <div class="from_input">
          <input type="password" v-model="from.password2" @blur="inputpasswordfn2">
        </div>
      </div>
    </div>
    <div class="form_btn" @click="passwordfn">
      提交
    </div>
  </div>
</template>

<script>
  import {
    editpassword
  } from "../../../api/http.js"
  export default {
    name: "password",
    data() {
      return {
        from: {
          password_old:"",
          password: "",
          password2: "",
        }
      }
    },
    created() {

    },
    methods: {
     async passwordfn() {
        var addressreg = /^[^ ]/
        if (this.from.password_old == "" || !addressreg.test(this.from.password_old)) {
          return this.$message("输入正确的原密码")
        }
        if (this.from.password == ""||this.from.password2 == "" || !addressreg.test(this.from.password2)||!addressreg.test(this.from.password)||this.from.password2!=this.from.password) {
          return this.$message("输入正确的密码")
        }
        console.log(this.from);
        const res = await editpassword(this.from)
        console.log(res);
        if (res.data.code==200) {
          this.$message(res.data.code)
          this.$router.push({
            path:"/home"
          })
        } else{

        }
      },
      passwordoldfn(){
        var addressreg = /^[^ ]/
        addressreg.test(this.from.password_old) ? this.$message("输入正确") : this.$message("输入正确的密码")
      },
      inputpasswordfn(){
        var addressreg = /^[^ ]/
        addressreg.test(this.from.password) ? this.$message("输入正确") : this.$message("输入正确的密码")
      },
      inputpasswordfn2(){
        var addressreg = /^[^ ]/
        addressreg.test(this.from.password2)&&this.from.password==this.from.password2? this.$message("输入正确") : this.$message("两次输入密码不一致或者密码输入格式错误")
      }
    }
  }
</script>

<style lang="less">
  .password {
    padding: 33px 22px;
    width: 100%;
    height: 300px;
    border: 1px solid #CCCDCE;

    .form_btn {
      width: 80px;
      height: 36px;
      font-size: 14px;
      background-color: rgb(255, 68, 68);
      color: rgb(255, 255, 255);
      border-radius: 10px;
      line-height: 36px;
      text-align: center;
      margin-left: 180px;
      cursor: pointer;
    }

    .form {
      .from_item {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: flex-start;
        margin-bottom: 20px;

        .from_name {
          width: 100px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 14px;
        }

        .from_input {
          width: 260px;
          border: 1px solid #9A9A9A;
          border-radius: 5px;

          input {
            width: 100%;
            height: 40px;
            line-height: 40px;
            outline: none;
            border: none;
            background-color: transparent;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/view/password.vue